export default __webpack_public_path__ + "static/media/contact_us.ec2b3087.svg";